import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RepairHistoryService {

    constructor(private http: HttpClient, private configService: ConfigurationService) { }

    getRepairHistory(tenancyReference: string, startDate: string, endDate: string): Observable<any> {

        const repairsApiUrl = this.configService.getConfig()?.shell.api.repairsApiUrl;
        // const repairsApiUrl = 'https://connect.api.local/repairs/'
        return this.http.get<any>(repairsApiUrl + 'repairshistory?completedBaskets=true&tenancyReference=' + tenancyReference + '&startDate=' + startDate + '&endDate=' + endDate)

    }
}
